// extracted by mini-css-extract-plugin
module.exports = {"container":"DeletableChip-module__container--2g7Na","text":"DeletableChip-module__text--32o6L","chipCloseIcon":"DeletableChip-module__chipCloseIcon--5S_ER"};